//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import axios from "axios";
import Interceptor from "./Interceptor";
import { graphConfig } from "./AuthService";
import {
  ApplicationInsights,
  SeverityLevel,
} from "@microsoft/applicationinsights-web";
import { createBrowserHistory } from "history";
import {
  AppInsightsContext,
  ReactPlugin,
  withAITracking,
} from "@microsoft/applicationinsights-react-js";

class httpHelper {
  constructor() {
    this.ApiHostUrl = process.env.REACT_APP_ADMIN_API_URL;
    this.ApiCandidateAdmin = process.env.REACT_APP_CANDIDATE_API_URL;
    this.ApiNewAdminUrl = process.env.REACT_APP_NEW_ADMIN_URL;
    this.ApiCandidateUrl = process.env.REACT_APP_CANDIDATE_API_URL;
    this.ApiCoachUrl = process.env.REACT_APP_COACH_API_URL;
    this.BlobStorageUrl = process.env.REACT_APP_BLOB_STORAGE_URL;
    this.BlobStorageSASToken = process.env.REACT_APP_SAS_TOKEN;
    this.ApiFun07Url = process.env.REACT_APP_FUN07_API_URL;
    this.ApiFun03Url = process.env.REACT_APP_FUN03_API_URL;
    this.graphAPIEndPoint = graphConfig.graphMeEndpoint;
    this.CMSApiHostUrl = process.env.REACT_APP_ADMIN_CMS_API_URL;
    this.CMSapiKey = process.env.REACT_APP_ADMIN_CMS_API_KEY;
  }

  async get(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiHostUrl + url, data);
  }

  async post(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiHostUrl + url, data);
  }

  async candidateGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiCandidateUrl + url, data);
  }

  async candidatePost(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiCandidateUrl + url, data);
  }

  async canDetailsGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiCandidateAdmin + url, data);
  }

  async canDetailsPost(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiCandidateAdmin + url, data);
  }

  async canDetailsPut(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.put(this.ApiCandidateAdmin + url, data);
  }

  async adminGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiNewAdminUrl + url, data);
  }

  async adminPost(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiNewAdminUrl + url, data);
  }
  async coachGet(url, data) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiCoachUrl + url, data);
  }
  async jobLandedGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiCandidateUrl + url, data);
  }

  async adminPut(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.put(this.ApiNewAdminUrl + url, data);
  }

  async adminDelete(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.delete(this.ApiNewAdminUrl + url, data);
  }
  async candidateLogin(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiCandidateUrl + url, data);
  }
  async AssessmentCountGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiFun07Url + url, data);
  }
  async AppiledJobsCountGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiFun03Url + url, data);
  }
  async EventCountGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiFun07Url + url, data);
  }
  async CandidateActivityGet(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiCandidateAdmin + url, data);
  }
  async CandidateCreateActivity(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiCandidateAdmin + url, data);
  }

  //**this function is for app Insight */
  UseAppInsight(response) {
    var reactPlugin = new ReactPlugin();
    const browserHistory = createBrowserHistory({ basename: "" });
    var appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: process.env.REACT_APP_INSIGHT_KEY,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableAjaxTracking: true,
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
        },
      },
    });
    appInsights.loadAppInsights();
    let userName = JSON.parse(window.sessionStorage.getItem("UserAccount"))[
      "email"
    ];
    let payload;
    if (JSON.parse(window.localStorage.getItem("setIdTokenClaims")) !== null) {
      payload = {
        Severity: SeverityLevel.Error.toString(),
        userName: userName?.email,
        Time: new Date(),
      };
    }
    let url = response?.config.url;
    let errorMessage = response?.data?.errorMessage
      ? response?.data?.errorMessage
      : response?.data?.message
        ? response?.data?.message
        : url;
    let status = response?.status;
    let xCorrelationId = response?.headers["x-correlation-id"]
      ? response?.headers["x-correlation-id"]
      : "no-correlation Id found";
    reactPlugin.trackException({
      error: { errorMessage },
      severityLevel: SeverityLevel.Error,
      properties: {
        url: url,
        status: status,
        xCorrelationId: xCorrelationId,
        ...payload,
      },
    });
  }
  //**end here */

  async jsonGet(url, data = {}) {
    let _instance = new Interceptor().getInstanceForLabels();
    return _instance.get(
      this.BlobStorageUrl + url + "?" + this.BlobStorageSASToken,
      data
    );
  }

  async getCountriesData(url) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiNewAdminUrl + url);
  }

  async getTimezoneData(url) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiHostUrl + url);
  }

  async postMessage(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.post(this.ApiNewAdminUrl + url, data);
  }
  async graphUserApiGet(activeEmail) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.graphAPIEndPoint + "/" + activeEmail);
  }

  async graphUserApiGet(activeEmail) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.graphAPIEndPoint + "/" + activeEmail);
  }

  async getSystemMessages(url) {
    let _instance = new Interceptor().getInstance();
    return _instance.get(this.ApiNewAdminUrl + url);
  }

  async updateSystemMessage(url, data = {}) {
    let _instance = new Interceptor().getInstance();
    return _instance.put(this.ApiNewAdminUrl + url, data);
  }

  async deleteSystemMessage(url) {
    let _instance = new Interceptor().getInstance();
    return _instance.delete(this.ApiNewAdminUrl + url);
  }

  async CMSpost(url, body) {
    let genericData = { categoryname: 'Default', language: body?.language ?? 'en-US', sitename: "cirrusadmin", };
    let requestBody = { ...body, ...genericData };

    let response = await axios.post(this.CMSApiHostUrl + url, requestBody, {
      headers: {
        sc_apikey: this.CMSapiKey,
        "Content-Type": "application/json",
      },
    });
    return response;
  }
}
export default httpHelper;
